//@ts-check

class AccountsHistoryDataService {
    constructor($http, Utility, $window, $timeout, LocalStorageService, NotificationService, InternalLinksService) {
        this.$http = $http;
        this.Utility = Utility;
        this.$window = $window;
        this.$timeout = $timeout;
        this.LocalStorageService = LocalStorageService;
        this.NotificationService = NotificationService;
        this.InternalLinksService = InternalLinksService;

        this.init();
    }

    init() {
        this.InternalLinksService.getLinks('/api/accounts/links');
        this.accountsHistorySummary = [];
        this.accountsHistory = null;
    }

    async getAccountsHistorySummary(schemeRef, units) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('GetAccountsHistorySummary');
            if (!url) {
                await this.InternalLinksService.getLinks('api/accounts/links', false);
            }
            if (!url) {
                url = await this.InternalLinksService.getLink('GetAccountsHistorySummary');
            }

            var cardCodes = [];
            units.forEach((item) => {
                cardCodes.push(item.CardCode);
            });

            url = url.replace('{schemeReference}', schemeRef).trim();

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, cardCodes, { headers });

            this.accountsHistorySummary = results.data;
            this.$timeout(() => promiseHandler.resolve(this.accountsHistorySummary));
        } catch (err) {
            const msg = `Error while loading account history summary.`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    async getAccountsHistory(selectedCardCode, dateFrom, dateTo) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            if (!selectedCardCode) {
                throw 'No cardCode supplied';
            }

            let url = await this.InternalLinksService.getLink('GetAccountsHistory');
            if (!url) {
                await this.InternalLinksService.getLinks('api/accounts/links', false);
            }
            if (!url) {
                url = await this.InternalLinksService.getLink('GetAccountsHistory');
            }

            url = url.replace('{cardCode}', selectedCardCode).trim();
            url = `${url}?dateFrom=${moment(dateFrom).format('L')}&dateTo=${moment(dateTo).format('L')}`;

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.get(url, { headers });

            this.accountsHistory = results.data;
            this.$timeout(() => promiseHandler.resolve(this.accountsHistory));
        } catch (err) {
            const msg = `Error while searching for account history.`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(msg, err));
        }

        return promise;
    }

    async getAccountsHistoryReport(cardCode, dateFrom, dateTo) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });
            if (!cardCode) {
                throw 'No cardCode supplied';
            }

            let url = await this.InternalLinksService.getLink('AccountsHistoryReport');
            if (!url) {
                await this.InternalLinksService.getLinks('api/reporting/links', false);
            }
            if (!url) {
                url = await this.InternalLinksService.getLink('AccountsHistoryReport');
            }

            url = `${url}?cardCode=${cardCode}&dateFrom=${moment(dateFrom).format('L')}&dateTo=${moment(dateTo).format(
                'L'
            )}`;

            this.openNewTabReport(url, `Account History - ${cardCode}`);

            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            const msg = `Error while searching for account history.`;
            console.error(msg, err);
            this.$timeout(() => promiseHandler.reject(msg, err));
        }

        return promise;
    }

    openNewTabReport(url, title) {
        const newTab = this.$window.open(url, '_blank');
        if (newTab) {
            this.NotificationService.error('Please allow pop-ups for this site to view the report');
        }

        newTab.document.write(`
                <title>${title}</title>
                <style>
                    html:first-child>body {
                        margin: 0;
                        overflow: hidden;
                    }
                    iframe {
                        width: 100%;
                        height: 100%;
                    }
                </style>
                <iframe src="${url}">
                </iframe>
			`);
    }
}

export default /* @ngInject */ (
    $http,
    Utility,
    $window,
    $timeout,
    LocalStorageService,
    NotificationService,
    InternalLinksService
) =>
    new AccountsHistoryDataService(
        $http,
        Utility,
        $window,
        $timeout,
        LocalStorageService,
        NotificationService,
        InternalLinksService
    );
